module.exports = __webpack_public_path__ + "static/media/ui_ux_design.f05d03dd.svg";